// extracted by mini-css-extract-plugin
export default {"root":"PrivacyFooter_root__9KsBE","dot":"PrivacyFooter_dot__1o_FX","links":"PrivacyFooter_links__22g2C"};